import React, { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa";

import "./adminCreateArticle.css";

export default function CoverImageUpload({ file, onFileChange, inputId = "acaCoverImage" }) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return (
    <div className="acaCoverWrap">
      <input
        id={inputId}
        type="file"
        accept="image/png,image/jpeg,image/gif,image/webp"
        className="acaFileInput"
        multiple={false}
        onChange={(e) => {
          const list = e.target.files;
          const f = list?.length ? list[0] : null;
          onFileChange(f ?? null);
          e.target.value = "";
        }}
      />

      {preview ? (
        <div className="acaCoverHasFile">
          <div className="acaCoverPreview">
            <img src={preview} alt="" />
          </div>
          <div className="acaCoverActions">
            <label htmlFor={inputId} className="acaBtn acaBtnGhost">
              Replace
            </label>
            <button type="button" className="acaBtn acaBtnGhost" onClick={() => onFileChange(null)}>
              Remove
            </button>
          </div>
        </div>
      ) : (
        <label className="acaUploadBox acaCoverEmpty" htmlFor={inputId}>
          <div className="acaUploadInner">
            <div className="acaUploadIcon" aria-hidden="true">
              <FaUpload />
            </div>
            <div className="acaUploadTitle">Upload cover image</div>
            <div className="acaUploadHint">One image only — PNG, JPG, GIF or WebP</div>
          </div>
        </label>
      )}
    </div>
  );
}
